export default __webpack_public_path__ + "static/media/his4.f47d4b50.jpg";